module.exports = __webpack_public_path__ + "img/invalid.fd6841ca.png";